import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideCreatingResumeProps {
    onClose: () => void;
}

export const HelpGuideCreatingResume = ({
    onClose,
}: HelpGuideCreatingResumeProps) => {
    return (
        <div>
            <ModalHeader
                title="Creating a New Resume"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    When you create a new resume, you will be prompted to modify
                    the document to suit your preferences before you enter the
                    Resume Builder.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    <strong>Modifying Preferences:</strong> You can always
                    modify your preferences after entering the Resume Builder.
                </AppText>
                <AppText variant="regular">
                    <strong>Default Resume:</strong> You will receive a default
                    resume to edit once you have entered the Resume Builder.
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
